import api from './api';

export interface CuentaCorrienteSaldo {
  nroCliente: number;
  nombre: string;
  saldoTotal: number;
  saldoVencido: number;
  saldoVigente: number;
  ultimaActualizacion: string;
}

export interface CuentaCorrienteComprobante {
  compania: string;
  nroCliente: string;
  nombre: string;
  fecha: string;
  comprobante: string;
  numero: string;
  importe: number;
  saldoDeb: number;
  saldoHab: number;
  fechaVenc: string;
  saldo: number;
  nroTipoFormulario: string;
  moneda: number;
  nroFormulario: number;
}

export interface PaginatedResponse<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

interface GetSaldosParams {
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string;
}

interface GetComprobantesParams {
  pageNumber?: number;
  pageSize?: number;
}

const parseResponse = <T>(data: unknown): T => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as T;
    } catch (error) {
      console.error('No se pudo parsear la respuesta de Cuenta Corriente:', error);
      throw new Error('Respuesta inválida del servidor de Cuenta Corriente');
    }
  }

  return data as T;
};

const getSaldos = async ({
  pageNumber = 1,
  pageSize = 20,
  searchTerm
}: GetSaldosParams = {}): Promise<PaginatedResponse<CuentaCorrienteSaldo>> => {
  const params: any = {
    pageNumber,
    pageSize
  };
  
  if (searchTerm) {
    params.searchTerm = searchTerm;
  }
  
  const response = await api.get('/api/CuentaCorriente/saldos', {
    params,
    headers: {
      Accept: 'text/plain'
    }
  });

  return parseResponse<PaginatedResponse<CuentaCorrienteSaldo>>(response.data);
};

const getComprobantesCliente = async (
  nroCliente: number,
  {
    pageNumber = 1,
    pageSize = 50
  }: GetComprobantesParams = {}
): Promise<PaginatedResponse<CuentaCorrienteComprobante>> => {
  const response = await api.get(`/api/CuentaCorriente/cliente/${nroCliente}`, {
    params: {
      pageNumber,
      pageSize
    },
    headers: {
      Accept: 'text/plain'
    }
  });

  return parseResponse<PaginatedResponse<CuentaCorrienteComprobante>>(response.data);
};

export interface EstadisticasCuentaCorriente {
  totalClientesConCuentaCorriente: number;
  saldoTotalGeneral: number;
  saldoVencidoTotal: number;
  totalMovimientos: number;
  ultimaActualizacion: string;
  nroVendedorFiltrado: number | null;
  usuarioFiltrado: string | null;
}

const getEstadisticas = async (): Promise<EstadisticasCuentaCorriente> => {
  const response = await api.get<EstadisticasCuentaCorriente>('/api/CuentaCorriente/estadisticas');
  return response.data;
};

const cuentaCorrienteService = {
  getSaldos,
  getComprobantesCliente,
  getEstadisticas
};

export default cuentaCorrienteService;
